export enum ScheduleType {
  noschedule,
  once,
  recurring,
  predefined
}
